import React from 'react';

function RailwaysIcon({ w, h, className, childrenClassNames }) {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={w}
      height={h}
      viewBox="0 0 36 36"
    >
      <path
        fillRule="evenodd"
        className={childrenClassNames?.path}
        d="M22 25c0 1.107.893 2 2 2s2-.893 2-2-.893-2-2-2-2 .893-2 2zm-11.143-6.887C13.237 20.038 15.619 21 18 21c2.381 0 4.762-.962 7.143-2.887A5 5 0 0 0 27 14.224v-.557c0-1.629-1.2-3.008-2.812-3.234A44.563 44.563 0 0 0 18 10c-2.063 0-4.125.144-6.188.433A3.265 3.265 0 0 0 9 13.667v.557a5 5 0 0 0 1.857 3.889zM10 25c0 1.107.893 2 2 2s2-.893 2-2-.893-2-2-2-2 .893-2 2zm14.834 6.215C22.869 32.345 20.498 33 18 33c-2.495 0-4.864-.654-6.827-1.782l-1.378 2.296a1 1 0 0 1-.857.486h-.934a.85.85 0 0 1-.728-1.286L9.084 29.7C7.182 27.962 6 25.657 6 23.086V11.36C6 6.669 12.432 4 17.864 4 23.867 4 30 6.67 30 11.359v11.727c0 2.569-1.18 4.871-3.079 6.61l1.811 3.018A.85.85 0 0 1 28.004 34h-.933a1 1 0 0 1-.858-.486l-1.38-2.3zM18 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
      />
    </svg>
  );
}

RailwaysIcon.defaultProps = {
  w: 16,
  h: 16,
  childrenClassNames: {},
};

export default RailwaysIcon;
